import { computed, type Ref } from 'vue'
import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'

/**
 * Функция загрузки списка типов объектов
 */
export const useLoadObjectTypesEdges = (fromId: Ref<string>) => {
  const http = useHttp()

  const queryKey = computed(() => ['load_object_types_edges', fromId])

  const url = computed(() => {
    return `/types/${fromId.value}/links`
  })

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: computed(() => !!fromId.value),
  })
}
